import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { hunterTier } from "../lib/constants";
import { Crosshair, Trophy, ChevronRight } from "lucide-react";

// Spotlights the reporter with the most confirmed busts this calendar month.
export const HunterOfMonth = () => {
  const navigate = useNavigate();
  const [h, setH] = useState(null);

  useEffect(() => {
    api.get("/hunter-of-the-month").then(({ data }) => setH(data)).catch(() => setH(null));
  }, []);

  if (!h) return null;
  const tier = hunterTier(h.total_busts) || { label: "Hunter", color: "#00FF87" };

  return (
    <section data-testid="hunter-of-month" className="mx-auto max-w-7xl px-4 pt-10 sm:px-6">
      <button
        onClick={() => h.user_id && navigate(`/hunters/${h.user_id}`)}
        className="group relative block w-full overflow-hidden rounded-2xl border border-[#FFB800]/30 bg-gradient-to-br from-[#1A1405] via-[#0F1424] to-[#0F1424] p-6 text-left transition-all hover:border-[#FFB800]/60 sm:p-8"
      >
        <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-[#FFB800]/10 blur-3xl" />
        <div className="relative flex flex-wrap items-center gap-5">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[#FFB800]/15 text-[#FFB800]">
            <Trophy size={30} />
          </div>
          <div className="min-w-0 flex-1">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-[#FFB800]/40 bg-[#FFB800]/15 px-3 py-1 text-xs font-bold uppercase tracking-wider text-[#FFB800]">
              <Crosshair size={12} /> Hunter of the Month · {h.month}
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-white sm:text-3xl">{h.name}</h2>
            <p className="mt-1 flex flex-wrap items-center gap-2 text-sm text-[#94A3B8]">
              <span className="rounded px-1.5 py-0.5 text-[11px] font-bold uppercase" style={{ color: tier.color, backgroundColor: `${tier.color}26` }}>{tier.label}</span>
              busted <span className="font-bold text-white">{h.busts_this_month}</span> cheater{h.busts_this_month === 1 ? "" : "s"} this month.
            </p>
          </div>
          <div className="ml-auto text-right">
            <div className="font-heading text-4xl font-black text-[#FFB800]">{h.busts_this_month}</div>
            <div className="text-xs font-bold uppercase tracking-wider text-[#64748B]">busts in {h.month}</div>
            <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-[#FFB800] opacity-0 transition-opacity group-hover:opacity-100">
              View profile <ChevronRight size={13} />
            </span>
          </div>
        </div>
      </button>
    </section>
  );
};
